<template>
  <schedule-list-masters />
</template>

<script>
import scheduleListMasters from '@/components/lists/schedule/scheduleListMasters'

export default {
    components: {
        scheduleListMasters,
    },
}
</script>
